<div class="developer-tools-container">
  <div class="entity-content">
    @for (line of jsonLines(); track line.number) {
      <div class="json-line">
        <span class="line-number">{{ line.number }}</span>
        <span class="line-content">@for (token of line.tokens; track $index) {<span [class]="'token token-' + token.type">{{ token.text }}</span>}</span>
      </div>
    }
  </div>
  <div class="actions">
    <app-button innerId="btn-3ou5w9H_" label="Cerrar" styleClass="primary small" (action)="close()" />
  </div>
</div>
